import React from 'react'

import './CardListProcedureDiagnosis.scss'
import CardDiagnosisProcedure from '../CardDiagnosisProcedure/CardDiagnosisProcedure'
import { useState } from 'react'
import { useEffect } from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'

// TODO investigate slow load lag
const CardListProcedureDiagnosis = ({
  selectedList,
  setSelectedDiagnosis,
  type,
  visible,
  isProgressNote,
  serviceDate,
  showDescription,
}) => {
  const [selectedListItems, setSelectedListItems] = useState(selectedList)

  useEffect(() => {
    setSelectedListItems(selectedList?.filter((diagnosis) => diagnosis !== undefined))
  }, [selectedList])

  const handleRemove = (item) => {
    if (item) {
      const selectedListRemove = selectedList.filter(
        (removeItem) =>
          removeItem?.code !== item?.code ||
          JSON.stringify([...(removeItem?.modifiers || [])].sort()) !==
            JSON.stringify([...(item?.modifiers || [])].sort()),
      )

      setSelectedDiagnosis(selectedListRemove)
    }
  }

  const onModifierAdd = (item, i) => {
    if (item !== undefined) {
      const selectedListWithMod = [...selectedList]
      let index = i !== undefined ? i : -1

      if (i === undefined) {
        selectedList.find((code, i) => {
          if (code.code === item.code) {
            if (code?.modifiers?.[0] !== item?.code?.modifiers?.[0]) {
              index = i
              return i
            }
          }
        })
      }

      if (index > -1) {
        selectedListWithMod[index] = item
      }

      setSelectedDiagnosis(selectedListWithMod)
    }
  }

  const addItem = () => {
    let indexArray = [{ data: 'empty' }]
    for (let i = selectedList.length + 1; i <= 3; i++) {
      indexArray.push(i)
    }

    return (
      <>
        {indexArray.map((item, index) => {
          return (
            <div className="selectedCardContainer" key={index}>
              <p className="diagnosis-select-number none"></p>
              <div
                key={item}
                className={
                  visible
                    ? 'selecteddiagnosisCardContent diag-popup'
                    : isProgressNote
                      ? 'diag-progress'
                      : 'selecteddiagnosisCardContent'
                }
              >
                Drag to add {type === 'DIAGNOSIS' ? 'diagnosis' : 'procedure'} code
              </div>
            </div>
          )
        })}
      </>
    )
  }

  const onDragEnd = (result) => {
    if (!result.destination) {
      return
    }
    const content = reorder(selectedListItems, result.source.index, result.destination.index)
    setSelectedListItems(content)
  }

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)
    setSelectedDiagnosis(result)
    return result
  }

  return (
    <div
      className={visible ? 'selected-card-scroll-popup' : 'selectedCardContainer'}
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided) => {
            return (
              <div ref={provided.innerRef} className="selectedWrapper" style={{ width: '100%' }}>
                {selectedListItems?.length > 0 &&
                  selectedListItems?.map((item, index) => {
                    const key =
                      type === 'PROCEDURE'
                        ? item.code + '-' + (item?.modifiers || []).join('-')
                        : item?.code
                    return (
                      <div key={key}>
                        {item?.code && (
                          <>
                            <Draggable draggableId={key} index={index}>
                              {(provided, snapshot) => (
                                <div
                                  className={
                                    isProgressNote
                                      ? 'selectedCardContainer-progress'
                                      : 'selectedCardContainer'
                                  }
                                >
                                  <p className="diagnosis-select-number">{index + 1}</p>

                                  <CardDiagnosisProcedure
                                    key={item._id}
                                    item={item}
                                    serviceDate={serviceDate}
                                    icon={'minus'}
                                    index={index}
                                    handleAddRemove={handleRemove}
                                    onModifierAdd={onModifierAdd}
                                    toggleFavorite={true}
                                    selectedList={selectedListItems}
                                    type={type}
                                    innerRef={provided.innerRef}
                                    showDescription={showDescription}
                                    panelSelected={true}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  />
                                </div>
                              )}
                            </Draggable>
                            {type === 'DIAGNOSIS' && index === 0 && (
                              <p className="primary-code">Primary code</p>
                            )}
                          </>
                        )}
                      </div>
                    )
                  })}

                {addItem()}
              </div>
            )
          }}
        </Droppable>
      </DragDropContext>
    </div>
  )
}
export default CardListProcedureDiagnosis
